export const allVarsObj = {
    // 工作桌面导航背景颜色
    '--workbench-nav-bg-color': 'transparent',
    // 工作桌面导航栏搜索框hover边框颜色
    '--workbench-search-app-hover-border-color': '#7d8baf',
    // 工作桌面导航栏搜索框hover背景色
    '--workbench-search-app-hover-bg-color': 'transparent',
    // 工作桌面导航栏搜索框默认边框颜色
    '--workbench-search-app-border-color': 'transparent',
    // 工作桌面导航栏搜索框默认背景色
    '--workbench-search-app-bg-color': 'transparent',
    // 工作桌面导航栏搜索框默认文字颜色
    '--workbench-search-app-input-color': 'transparent',
    // 工作桌面导航栏搜索框focus颜色
    '--workbench-search-app-focus-color': '#fff',
    // 工作桌面导航栏应用菜单扇叶颜色
    '--workbench-nav-allapps-color': 'transparent',
    // 工作桌面导航栏应用菜单扇叶hover颜色
    '--workbench-nav-allapps-hover-color': 'transparent',
    // 面包屑文字颜色 
    '--workbench-nav-breadcrumb-color': 'transparent',
    // 面包屑中间箭头颜色
    '--workbench-nav-breadcrumb-color1': '#fff',
    // 面包屑hover底色
    '--workbench-nav-breadcrumb-hover-bg-color': 'transparent',
    // 面包屑当前节点文字颜色
    '--workbench-nav-breadcrumb-current-color': '#fff',
    // 导航栏图标颜色 集团切换
    '--workbench-nav-icon-color': '#fff',
    // 应用菜单 标题 颜色
    '--workbench-allapps-title-color': 'transparent',
    // 应用菜单 新增图标 颜色
    '--workbench-allapps-add-icon-color': '#555',
    // 应用菜单 竖线颜色
    '--workbench-allapps-line-color': 'transparent',
    // 应用菜单 hover 背景色
    '--workbench-allapps-item-hover-bg': '#f0f5ff',
    // 桌面配置顶部页签文字 底部横线 颜色
    '--workbench-desktop-setting-title-color': 'transparent',
    // 集团切换 消息中心 等下拉区域背景色
    '--workbench-nav-drop-down-bg-color': '#fff',
    // 集团切换 消息中心 等下拉区域阴影
    '--workbench-nav-drop-down-box-shadow-color': '0 2px 8px rgba(0, 0, 0, 0.15)',
    // 集团切换 消息中心 等下拉区常规文字颜色
    '--workbench-nav-drop-down-title-color': '#2b2c42',
    // // 集团切换 消息中心 等下拉区域禁用或置灰文字颜色
    // '--workbench-nav-drop-down-title-disable-color': '#aeaeae',
    // 集团切换 消息中心 等下拉区每一项hover背景色
    '--workbench-nav-drop-down-item-hover-bg-color': '#f2f2f2',
    // ant-tabs-bar border颜色
    '--workbecnch-ant-tabs-bar-border-bottom-color': '#e8e8e8',
    // 导航栏border-bottom 颜色
    '--workbench-nav-border-bottom-color': '#fcedec',
    // 桌面背景色
    '--workbench-home-bg-color': 'transparent',
    // 部件和应用背景色
    '--workbench-app-bg-color': '#fff',
    // 部件和应用标题颜色
    '--workbench-app-title-color': '#333',
    // 部件标题 未选中颜色
    '--workbench-app-title-color1': '#767B83',
    // 新手引导 背景色1
    '--workbench-novide-bg1': '#f9fbff',
    // 新手引导 背景色2
    '--workbench-novide-bg2': '#f9fbff',
    // 桌面分组文字颜色
    '--workbench-app-container-title-color': '#606069',
    // 常用应用 应用hover背景色
    '--workbench-app-group-item-hover-bg': '#f9f9f9',
    // 常用应用 图标hover背景色
    '--workbench-app-group-icon-hover-bg': '#edf1f2',
    // 常用应用 应用图标背景色
    '--workbench-app-icon-content-bg': '#f1f4ff',
    // 全部应用 整体 背景色
    '--workbench-allapps-bg': '#f2f4f7',
    // 全部应用 左侧整体背景色
    '--workbench-allapps-sider-bg': '#f2f4f7',
    // 全部应用 右侧整体背景色
    '--workbench-allapps-right-bg': '#f2f4f7',
    // 应用菜单 应用 文字颜色1
    '--workbench-allapps-title-color1': '#535360',
    // 应用菜单 应用 文字颜色2
    '--workbench-allapps-title-color2': '#535360',
    // 应用菜单 领域 hover背景色
    '--workbench-allapps-left-item-hover-bg': '0 2px 5px 0 #d5dce6',
    // 个人中心文字hover颜色
    '--workbench-user-info-hover': 'transparent',
    // 个人中心侧拉背景色
    '--workbench-user-bg': '#f4f5f6',
    // 个人中心 每一块背景色
    '--workbench-user-item-bg': '#fff',
    // 主题hover背景色
    '--workbench-skin-hover-bg': '#f1f1f1',
    // 个人中心 文字颜色
    '--workbench-user-text-color': '#111',
    // 个人中心 下划线颜色
    '--workbench-user-line-bg': '#f2f2f2',
    // 页面 标题区背景色
    '--workbench-page-header-bg': '#fff',
    // 页面 底部背景色
    '--workbench-page-footer-bg': '#fff',
    // 页面 标题区文字颜色
    '--workbench-page-header-text-color': '#111',
    // 页面 左侧整体背景色
    '--workbench-page-left-bg': '#f4f5f6',
    // 页面 左侧 每一块 背景色
    '--workbench-page-left-item-bg': '#fff',
    // 页面 左侧 每一块 hover 背景色
    '--workbench-page-left-item-hover-bg': '#fff',
    // 页面 左侧 每一块字体颜色
    '--workbench-page-text-color': '#fff',
    // 页面 右侧 整体背景色
    '--workbench-page-right-bg': '#fff',
    // 页面 右侧 border-right
    '--workbench-page-right-border-color': '#ccc',
    // 页面 左侧 每一块边框
    '--workbench-page-left-item-border': '1px solid #f0f4fb',
    // 页面 左侧 线颜色
    '--workbench-page-left-line-color': '#f7f7f7',
    // 桌面配置 整体背景色
    '--workbench-desktop-setting-bg': 'transparent',
    // 桌面配置 分组页签背景色
    '--workbench-home-tab-bg-color': '#fff',
    // 桌面配置 当前分组页面背景色
    '--workbench-home-current-tab-bg-color': 'transparent',
    // 桌面配置 非当前分组页签文字颜色
    '--workbench-home-tab-title-color': '#555',
    // 桌面配置 浏览态 当前分组页签文字颜色
    '--workbench-home-tab-current-title-color': '#fff',
    // 桌面配置 编辑态 当前分组页签文字颜色
    '--workbench-home-tab-editable-current-title-color': 'transparent',
    // 桌面配置 编辑态 非当前分组页签文字颜色
    '--workbench-home-tab-editable-title-color': 'transparent',
    // 桌面配置 左侧侧拉收起时背景色
    '--workbench-home-addapp-close-bg': '#bdbdbd',
    // 桌面配置 左侧侧拉展开时背景色
    '--workbench-home-addapp-expand-bg': '#f1f4f8',
    // 桌面配置 左侧侧拉收起时边框色
    '--workbench-home-addapp-close-border': 'rgba(255, 255, 255, .6)',
    // 桌面配置 左侧侧拉展开时边框色
    '--workbench-home-addapp-expand-border': '#E7EBEF',
    // 桌面配置 左侧侧拉收起时加号图标
    '--workbench-home-addapp-icon-color': '#ccc',
    // 桌面配置 每组 右侧图标
    '--workbench-home-item-header-icon': '#505368',
    // 桌面配置 应用 部件右上角背景色
    '--workbench-home-app-bg': '#f3f4fc',
    // 桌面配置 应用 部件右上角图标 颜色
    '--workbench-home-app-icon': '#8e99b5',
    //桌面配置 左侧打开时背景色
    '--workbench-desktop-open-bg': '#f1f4f8',
    //桌面配置 左侧打开时添加图标颜色
    '--workbench-desktop-open-add-icon': '#ccc',
    //桌面配置 左侧打开时 每个应用hover border
    '--workbench-desktop-open-app-hover-border-color': '#c2c2c2',
    //桌面配置 左侧打开时 顶部tabs背景色
    '--workbench-desktop-open-tabs-bg': '#e8ecf2',
    //桌面配置 左侧打开时 顶部tabs当前背景色
    '--workbench-desktop-open-tabs-current-bg': '#f1f4f8',
    //桌面配置 左侧打开时 顶部tabs当前border
    '--workbench-desktop-open-tabs-current-border': '#d9d9d9',
    //桌面配置 左侧打开时 搜索框背景色
    '--workbench-desktop-open-search-box-bg': '#fff',
    //桌面配置 左侧打开时 搜索框背景色1
    '--workbench-desktop-open-search-box-bg1': '#fff',
    //桌面配置 左侧打开时 搜索框hover 清楚图标
    '--workbench-desktop-open-search-box-hover-icon': 'rgba(0,0,0,.25)',
    //桌面配置 左侧打开时 搜索框边框颜色
    '--workbench-desktop-open-search-box-border': '#d6d7db',
    //桌面配置 左侧打开时 标题区域背景色
    '--workbench-desktop-open-item-title-bg': '#fff',
    //桌面配置 左侧打开时 区域背景色
    '--workbench-desktop-open-item-bg': '#fff',
    //桌面配置 左侧打开时 标题名称颜色
    '--workbench-desktop-open-test1': '#a1a2a2',
    //桌面配置 左侧打开时 节点名称颜色
    '--workbench-desktop-open-test2': '#d9d9d9',
    // 业务设置 左侧字体颜色
    '--workbench-test-color1': '#111',
    // 勿扰模式弹框 
    '--workbench-disturbModal-ant-alert-bg': '#fffbe6',
    // 勿扰模式弹框 
    '--workbench-disturbModal-ant-alert-color': 'rgba(0,0,0,.65)',
    // 标准页面 label颜色
    '--workbench-nc-page-label': '#555',
    // 邮箱修改弹框 输入框背景色
    '--workbench-userinfo-modal-ant-input-bg': '#fff',
    // 邮箱修改弹框 输入框边框
    '--workbench-userinfo-modal-ant-input-border': '#d9d9d9',
    // 邮箱修改弹框 输入框颜色
    '--workbench-userinfo-modal-ant-input-color': '#111',
    // 账户设置 每一项边框颜色
    '--workbench-userinfo-item-border-color': '#d0d0d0',
    // 桌面配置底部背景色
    '--workbench-home-footer-bg': '#f7f8fa',
    // 桌面配置底部border
    '--workbench-home-footer-border': '#ccc',
    // 桌面配置 新增分组按钮
    '--workbench-home-add-group-bg': '#f3f4fc',
    // antd-dropdown 背景色
    '--workbench-ant-dropdown-menu-bg': '#fff',
    // antd-dropdown border
    '--workbench-ant-dropdown-menu-border': '#c1c1c1',
    // antd-dropdown 每一项hover 颜色
    '--workbench-ant-dropdown-menu-item-hover': '#f4f5f7',
    // 常用应用 左侧边框
    '--workbench-drag-modal-left-border': '#e7ebef',
    // 常用应用 下拉图标
    '--workbench-drag-modal-icon-down': 'rgba(0,0,0,.25)',
    // 常用应用 下拉框颜色
    '--workbench-drag-modal-cascader-color': '#6b6b6b',
    // 页面 头部区域border-bottom
    '--workbench-page-header-border': '#d9d9d9',
    // 模板设置 标题区border颜色
    '--workbench-template-setting-page-header-border': '#e0e0e0',
    // 模板设置 左右侧区域border
    '--workbench-template-setting-page-border1': '#eaeaea',
    // 模板设置 左右区域背景色
    '--workbench-template-setting-page-bg1': '#fff',
    // 模板设置 中间区域背景色
    '--workbench-template-setting-page-bg2': '#f0f2f5',
    // 模板设置 label颜色
    '--workbench-template-setting-page-label': '#2b3441',
    // antd input 
    '--workbench-ant-input-bg': '#fff',
    // antd input 
    '--workbench-ant-input-border': '#d9d9d9',
    // antd input 
    '--workbench-ant-input-color': '#111',
    // antd input 
    '--workbench-ant-input-hover-border': '#40a9ff',
    //模板设置 文字
    '--workbench-template-setting-page-color': '#111',
    //模板设置 可选区域背景色
    '--workbench-template-setting-page-bg3': '#fff',
    //模板设置 hover color
    '--workbench-template-setting-page-hover-color': '#111',
    //模板设置 中间区域背景色
    '--workbench-template-setting-page-bg4': '#fff',
    //模板设置 中间区域背景色
    '--workbench-template-setting-page-bg5': '#f6f6f6',
    //模板设置 文字
    '--workbench-template-setting-page-color1': '#555',
    //模板设置 border
    '--workbench-template-setting-page-border2': '#e4e4e4',
    //模板设置 中间区域背景色
    '--workbench-template-setting-page-bg6': 'transparent',
    //模板设置 文字
    '--workbench-template-setting-page-color2': '#474d54',
    // 模板设置 弹框
    '--workbench-template-setting-page-modal-color1': '#f3f3f3',
    // 模板设置 弹框
    '--workbench-template-setting-page-modal-color2': '#eee',
    // 图片透明度
    '--workbench-img-opacity': '1',
    // 桌面配置 button border
    '--workbench-desktop-footer-border': '#c6ccd7',
    // 应用菜单 三级菜单背景色
    '--workbench-allapps-bg1': 'rgba(241, 241, 241, .5)',
    // 导航栏工作台选中激活颜色
    '--workbench-nav-active': '#F0F0F0',
    //搜索栏中主色调设为白色
    '--workbench-nav-search-color': '#ffffff',
    //搜索栏默认色边框颜色
    '--workbench-nav-border-color': '#D7D7D7',
    //搜索栏边框聚焦颜色
    '--workbench-nav-border-color-focus': 'rgba(255,255,255,0.2)',
    //搜索栏边框hover颜色
    '--workbench-nav-border-color-hover': '#505766',
    //搜索栏竖线透明度
    '--workbench-nav-search-shuxian-opacity': 0.2,
    //搜索栏select框背景色
    '--workbench-nav-select-bg-color': 'white',
    //搜索栏select框文字hover时的颜色
    '--workbench-nav-select-text-color': 'rgba(240, 240, 240)',
    //搜索框联想面板的字体颜色
    '--workbench-nav-search-more-color': '#2B2C42',
    //搜索框联想面板的分类标题颜色
    '--workbench-nav-search-title-color': '#111111',
    //搜索栏下拉框图标颜色
    '--workbench-nav-select-drop-color': '#999999',
    //搜索栏下拉选中字体颜色
    '--workbench-nav-select-drop-text-color': 'rgba(233,240,250)',
    //搜索栏暂无数据搜索图标颜色
    '--workbench-nav-search-icon-sousuo1-color': '#d1d1d1',
    //搜索栏横线颜色
    '--workbench-nav-search-hr-color': '#F0F0F0',
    //搜索框联想面板标题背景颜色
    '--workbench-nav-title-bg-color': '#F8F8F8',
    //内部页签标签栏背景色
    '--workbench-tab-wrapper-bg': '#F5F7F9',
    //内部页签标签栏背景下划线
    '--workbench-tab-bottom-color': '#F5F7F9',
    //内部页签选中字体颜色
    '--workbench-tab-active-color': '#ee2233',
    // 面包屑首页下拉图标颜色
    '--workbench-breadcrumb-home-icon-c': '#111',
    // 面包屑首页下拉图标透明度
    '--workbench-breadcrumb-home-icon-o': 0.6,
    // 面包屑首页下拉图标边框透明度
    '--workbench-breadcrumb-home-icon-bo': 0.2,
    // 内部页签右侧节点和tab右键列表下拉
    '--workbench-inside-tab-dropdown-bk': '#fff',
    // 内部页签右侧节点列表下拉和tab右键item hover色
    '--workbench-inside-tab-dropdown-item-hover': '#EEF1F7',
    // tab右键文字颜色
    '--workbench-inside-tab-dropdown-text': '#333',
    // ant-modal相关
    '--workbench-ant-modal-content-color': '#f3f3f3',
    '--workbench-ant-modal-header-bg': '#f1f1f1',
    '--workbench-ant-modal-border-color': '#e8e8e8',
    '--workbench-subjectsetting-preview-search-area': '#E0E4EC',
    // 应用hover时阴影色
    '--workbench-app-hover-shadow': '#b3bac9',
    // ant-form-extra
    '--workbench-ant-form-extra-color': 'rgba(0, 0, 0, .45)',
    // 背景设置背景色
    '--workbench-background-setting-bg': '#fafafa',
    // 个人中心 设置 按钮
    '--workbench-disturb-setting-btn': '#0033CC',
    // 菜单项边框色
    '--workbench-allapps-border-color': '#e2ecff',
    // 集团下拉hover背景色
    '--workbench-group-list-hover-bg-color': "#F9F9F9",
    // 集团下拉选中背景色
    '--workbench-group-list-select-bg-color': "#F4F8FF",
    // 基于主色hsl格式，l值为93
    '--workbench-color-primary-l93': "rgba(238, 34, 51, 0.04)",
    '--workbench-color-primary-l95': "#EBEBEB",
};